import React from "react";
import Hawksbill from "./Hawksbill";
import Loggerhead from "./Loggerhead";
import KempsRidley from "./KempsRidley";
import Green from "./Green";
import Leatherback from "./Leatherback";


import "./motion.css";




const Offers = [
  {
    id: "0",

    text: <Hawksbill />,
  },
  {
    id: "1",

    text: <KempsRidley />,
  },
  {
    id: "2",

    text: <Loggerhead />,
  },
  {
    id: "3",

    text: <Green />,
  },
  {
    id: "4",

    text: <Leatherback />,
  },

];

function Offer() {
  // const [width, setWidth] = useState(0);
  // const carousel = useRef();

  // useEffect(() => {
  //   setWidth(carousel.current.scrollWidth - carousel.current.offsetWidth);
  // }, []);



  return (
    <div className="mt-5">
      <div className="text-2xl my-5 text-left text-[#F27920]">
        CLASSIFICATION OF FLORIDA SEA TURTLES
      </div>


      <div>
        <div>
          {Offers.map((offer) => {
            return (
              <div className=" p-2" key={offer.id}>
                <div>{offer.text}</div>
              </div>
            );
          })}
        </div>
      </div>

    </div>
  );
}

export default Offer;
